import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MyAccountComponent } from './account/my-account/my-account.component';
import { LoginLayoutComponent } from './layout/login-layout.component';
import { PostLoginLayoutComponent } from './layout/postLogin-layout.component';
import { DashboardOrganizerComponent } from './dashboard/dashboard-organizer/dashboard-organizer.component';
import { StringHelpers } from './shared/helpers/string-helpers';
import { CommonModule } from '@angular/common';
import { SignalrService } from './shared/services/signalr.service';
import { AdministrationModule } from './administration/administration.module';
import { MyAccountBillingComponent } from './account/my-account/my-account-billing/my-account-billing.component';
import { AuthModule } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { MyAccountPlayerPaymentComponent } from './account/my-account/my-account-player-payment/my-account-player-payment.component';
import { CallbackComponent } from './layout/callback/callback.component';
import { PostLoginOutingLayoutComponent } from './layout/outing/postLogin-outing-layout.component';
import { PostLoginSimBookLayoutComponent } from './layout/simbook/postLogin-simbook-layout.component';
import { SimbookDashboardComponent } from './simulator-booking/simbook-dashboard/simbook-dashboard.component';
import { SimulatorBookingModule } from './simulator-booking/simulator-booking.module';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { AccountService } from './account/account.service';
import { providePrimeNG } from 'primeng/config';
import PrimengGolftechPreset from './widget/primeng/primeng-golftech-preset';

@NgModule({ declarations: [
        AppComponent,
        LoginLayoutComponent,
        PostLoginLayoutComponent,
        PostLoginOutingLayoutComponent,
        PostLoginSimBookLayoutComponent,
        DashboardComponent,
        MyAccountComponent,
        DashboardOrganizerComponent,
        MyAccountBillingComponent,
        MyAccountPlayerPaymentComponent,
        CallbackComponent,
        SimbookDashboardComponent
    ],
    exports: [],
    bootstrap: [AppComponent], 
    imports: [AdministrationModule,
        SimulatorBookingModule,
        SharedModule,
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AuthModule.forRoot(environment.auth0)], 
        providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        StringHelpers,
        SignalrService,
        AccountService,
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
              preset: PrimengGolftechPreset
            },
            ripple: true
          }),
    ] })
export class AppModule { }
